import { Component, ChangeDetectionStrategy } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';
import { ActivatedRoute, Router } from '@angular/router';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { AuthService } from 'app/@core/services/auth.service';
import { menu } from 'app/menu/menu';
import { universityMenu } from 'app/menu/university';
import { schoolMenu } from 'app/menu/school';
import { frontendMenu } from 'app/menu/frontend';
import { CoreMenu } from '@core/types';

@Component({
	template: `
		@if (visible) {
			<span
				[class]="class + (isDisabled ? ' disabled' : '')"
				[class.disabled]="isDisabled"
				(click)="!isDisabled && btnClickedHandler($event)">
				<fa-icon [icon]="icon" [class.text-muted]="isDisabled"></fa-icon>
			</span>
		}
	`,
	styles: [
		`
			.disabled {
				opacity: 0.5;
				cursor: not-allowed !important;
				pointer-events: none;
			}
			.text-muted {
				color: #6c757d !important;
			}
		`,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	standalone: false,
})
export class BtnIconCellRendererComponent implements ICellRendererAngularComp {
	private params: any;
	diplayText: string;
	class: string;
	icon: IconProp;
	isDisabled: boolean = false;
	visible = true;

	constructor(
		private _router: Router,
		private _route: ActivatedRoute,
		private _authService: AuthService
	) {}

	agInit(params: any): void {
		this.params = params;

		// Controlla se l'elemento è eliminato
		this.isDisabled = this.params.data?.deleted_at || (this.params.disabled && this.params.disabled(this.params.data));

		if (this.params.label) {
			this.diplayText = this.params.label;
		} else {
			this.diplayText = this.params.value;
		}

		if (this.params.class) {
			this.class = this.params.class;
		} else {
			this.icon = 'pen-to-square';
			this.class = 'btn btn-primary btn-icon';
		}

		// this.params.url = this.params.url.replace('{field}', this.params.data[this.params.field]);

		let indexStart = 0;
		const paramsName = [];
		let tempUrl = this.params.url;
		while (1) {
			indexStart = tempUrl.indexOf('{') + 1;

			if (indexStart === 0) {
				break;
			}

			let paramTemp = tempUrl.substr(indexStart);
			tempUrl = paramTemp;

			paramTemp = paramTemp.substr(0, paramTemp.indexOf('}'));
			paramsName.push(paramTemp);
		}

		if (this.params.url == '/') {
			this.params.url = `${this.params.data.cohort_school_university_of_x_school_university?.id}/edit`;
		} else {
			for (let paramName of paramsName) {
				const paramPath = paramName.split('.');

				let paramValue = undefined;

				let first = true;
				for (const paramNamePath of paramPath) {
					if (first) {
						paramValue = this.params.data[paramNamePath];
					} else {
						paramValue = paramValue?.[paramNamePath];
					}
					first = false;
				}

				this.params.url = this.params.url.replace(`{${paramName}}`, paramValue);
			}
		}

		// Se visible è passato esplicitamente, usa solo quello (la colonna gestisce la propria logica)
		// Altrimenti usa la permission inferita dalla route
		if (this.params.visible !== undefined) {
			this.visible = this.params.visible;
		} else {
			this.visible = this.checkPermission();
		}
	}

	private checkPermission(): boolean {
		if (this.params.permission) {
			const perms = Array.isArray(this.params.permission) ? this.params.permission : [this.params.permission];
			return this._authService.hasAnyPermission(perms);
		}

		const inferred = this.inferUpdatePermissionFromRoute();
		if (!inferred) {
			return true;
		}

		return this._authService.hasPermission(inferred);
	}

	private inferUpdatePermissionFromRoute(): string | undefined {
		const url = this.normalizeUrl(this._router.url);
		if (!url) {
			return undefined;
		}

		const allMenus: CoreMenu[] = [...menu, ...universityMenu, ...schoolMenu, ...frontendMenu];
		const matched = this.findMenuByUrl(allMenus, url);
		const viewPermission = matched?.permissions?.[0];
		if (!viewPermission) {
			return undefined;
		}

		return viewPermission.endsWith('.view') ? viewPermission.replace(/\.view$/, '.update') : viewPermission;
	}

	private findMenuByUrl(items: CoreMenu[], currentUrl: string): CoreMenu | undefined {
		for (const item of items || []) {
			const itemUrl = this.normalizeUrl(item.url);
			if (itemUrl && (itemUrl === currentUrl || currentUrl.startsWith(itemUrl + '/'))) {
				return item;
			}
			if (item.children?.length) {
				const found = this.findMenuByUrl(item.children as CoreMenu[], currentUrl);
				if (found) {
					return found;
				}
			}
		}
		return undefined;
	}

	private normalizeUrl(url?: string): string {
		if (!url) {
			return '';
		}
		return url.replace(/^\/+/, '').split('?')[0].split('#')[0];
	}

	btnClickedHandler($event: Event) {
		if (this.isDisabled) {
			$event.preventDefault();
			$event.stopPropagation();
			return;
		}
		if (this.params.url.startsWith('/')) {
			this._router.navigate([this.params.url]);
		} else {
			this._router.navigate([this.params.url], { relativeTo: this._route });
		}
	}

	// gets called whenever the cell refreshes
	refresh(params: ICellRendererParams) {
		return true;
		// set value into cell again
	}
}
